import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import cx from 'classnames';
import {
  prepareQuestions,
  prepareCategoryLabel,
  questionValue,
} from '../../shared/lib';
import { EDIT_PATH } from '../../shared/routes';
import SubmissionField from '../SubmissionField';

import styles from './styles';
import { camelize } from 'humps';

const renderSubmissionFields = ({ questions, context, data }) =>
  questions.map((question) => {
    return (
      <SubmissionField
        key={question.name}
        context={context}
        question={question}
        value={questionValue(question, data)}
      />
    );
  });

const renderSubmissionFieldsByCategory = ({ questions, context, data }) =>
  Object.keys(questions).map((category) => (
    <div key={category} className={styles.section}>
      <h3 className={styles.category}>
        {prepareCategoryLabel(questions[category].label)}
      </h3>
      {renderSubmissionFields({
        questions: questions[category].questions,
        context,
        data,
      })}
    </div>
  ));

function EditButton({ showEditButton }) {
  return (
    (showEditButton && (
      <Link to={EDIT_PATH} className={cx(styles.button, styles.editButton)}>
        Edit
      </Link>
    )) ||
    null
  );
}

export default function SubmissionFields({
  context,
  id,
  name,
  questions,
  hidden,
  data,
  isReadOnly,
  features,
}) {
  const preparedQuestions = prepareQuestions({
    questions,
    hidden,
    features,
    context,
    data,
    isSubmission: true,
  });

  // Ensure we drop you off at the top of the page on first render
  // For long forms, the scroll offset can get pretty high
  // We may need to make this smarter!
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
  }, []);

  return (
    <div className={cx(styles.fields, styles[camelize(`${name}Fields`)])}>
      <EditButton showEditButton={!isReadOnly && features.editable} />
      {features.categories &&
        renderSubmissionFieldsByCategory({
          questions: preparedQuestions,
          context,
          data,
        })}
      {!features.categories &&
        renderSubmissionFields({
          questions: preparedQuestions,
          context,
          data,
        })}
    </div>
  );
}

SubmissionFields.propTypes = {
  questions: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
};
